import React from 'react';
import { Building2 } from 'lucide-react';
import { Building } from './types';

type Props = {
  buildings: Building[];
  selectedBuildingId: string;
  onSelectBuilding: (buildingId: string) => void;
};

export const BuildingSelector = ({ buildings, selectedBuildingId, onSelectBuilding }: Props) => {
  return (
    <div className="flex gap-3 overflow-x-auto pb-2">
      {buildings.map((building) => (
        <button
          key={building.id}
          onClick={() => onSelectBuilding(building.id)}
          className={`
            flex items-center gap-2 px-4 py-2 rounded-lg whitespace-nowrap
            ${selectedBuildingId === building.id 
              ? 'bg-primary-500 text-white' 
              : 'bg-gray-100 hover:bg-gray-200 text-gray-700'}
          `}
        >
          <Building2 size={18} />
          <span>{building.name}</span>
          <span className="text-sm opacity-75">
            ({building.occupiedRooms}/{building.totalRooms})
          </span>
        </button>
      ))}
    </div>
  );
};